define([
  'react',
  'prop-types',
  'immutable',
  'underscore',
  'countdown',
  'es6!sumo/util',
  'jsx!launcher/views/listbuilder/wysiwyg/components/Component',
], (React, PropTypes, Immutable, _, countdown, Util, Component) => {
  const VALID_STYLE_ATTRS = [
    'color',
    'background',
    'backgroundColor',
    'fontFamily',
    'fontWeight',
    'fontStyle',
    'fontSize',
    'textAlign',
    'borderTopWidth',
    'borderLeftWidth',
    'borderBottomWidth',
    'borderRightWidth',
    'borderColor',
    'borderStyle',
    'borderTopLeftRadius',
    'borderTopRightRadius',
    'borderBottomLeftRadius',
    'borderBottomRightRadius',
    'lineHeight',
    'boxShadow',
    'textShadow',
  ];

  @Component({ disableVerticalResize: true })
  class Countdown extends React.Component {
    static propTypes = {
      id: PropTypes.string.isRequired,
      end: PropTypes.string,
      format: PropTypes.string,
      style: PropTypes.object,
    };

    static defaultProps = {
      style: Immutable.Map(),
    }

    constructor(props) {
      super(props);
      const { end } = this.props;

      this.state = {
        timeRemaining: countdown(new Date(), new Date(end)),
      };

      this.updateTimeRemaining = this.updateTimeRemaining.bind(this);
    }

    componentWillReceiveProps(nextProps) {
      const { end } = nextProps;
      this.updateTimeRemaining(end);
    }

    componentDidMount() {
      this.timer = setInterval(() => {
        const { end } = this.props;
        this.updateTimeRemaining(end);
      }, 1000);
    }

    componentWillUnmount() {
      clearInterval(this.timer);
    }

    updateTimeRemaining(end) {
      const { timeRemaining } = this.state;
      const newTimeRemaining = countdown(new Date(), new Date(end));

      if (timeRemaining !== newTimeRemaining) {
        this.setState({ timeRemaining: newTimeRemaining });
      }
    }

    render() {
      const {
        format,
        onMouseEnter,
        onMouseLeave,
      } = this.props;
      const { timeRemaining } = this.state;
      const style = _.pick(this.props.style.toJS(), VALID_STYLE_ATTRS);

      style.padding = '0';
      style.margin = '0';

      return (
        <div
          ref={(el) => this.textEl = el}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
        >
          <p style={style}>{Util.formatTime(timeRemaining, format)}</p>
        </div>
      );
    }
  }

  return Countdown;
});
